// extracted by mini-css-extract-plugin
export default {"rating":"Kw-z","numberOfStars":"Lw-z","count":"Mw-z","barGraphSpacing":"Nw-z","barGraph":"Ow-z"};